import { Box, Heading, HStack, VStack, Text, BoxProps } from '@chakra-ui/layout'
import React from 'react'

interface Props extends BoxProps {
  title: string
  description: string
  icon: any
}

const SettingBox = ({ title, description, icon, ...props }: Props) => {
  return (
    <Box
      spacing="2rem"
      borderTop="1px solid #e2e1e1"
      as={HStack}
      w="full"
      alignItems="center"
      py="1.4rem"
      {...props}>
      {icon}
      <VStack spacing="0.5rem" align="flex-start">
        <Text fontSize="1rem">{title}</Text>
        <Heading fontWeight="500" color="black" fontSize="1.2rem">
          {description}
        </Heading>
      </VStack>
    </Box>
  )
}

export { SettingBox }
